import script from "./AdminDevotional.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDevotional.vue?vue&type=script&setup=true&lang=js"

import "./AdminDevotional.vue?vue&type=style&index=0&id=78f80100&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78f80100"]])

export default __exports__